import React, { useEffect, useMemo, useState } from "react";
import { Dimensions, Platform, ScrollView, StyleSheet, TouchableOpacity, View } from "react-native";
import { ButtonSizeDLS, ButtonTypeDLS, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, HeaderTypeTokens, IconSizeTokens, IconTokens, ImageSizeTokens, SizeTypeTokens, StepperTypeTokens, TextAlignTokens, TypographyTypeDLS, } from "@voltmoney/schema";
import { ModalAlignmentEnum } from "@voltmoney/types";
import { Typography } from "../../typography/Typography";
import { Icon } from "../../icon/Icon";
import { isMobile } from "../../stack/utils";
import { getScreenType } from "../bankSelectPage/BankSelect";
import { Space } from "../../space/Space";
import { Button } from "../../button/Button";
import { Header } from "../../header/Header";
import BottomSheet from "../BottomSheet";
import Image from '../../image/Image';
import LottieView from "lottie-react-native";
import BottomSheetMf from "../../bottomSheetMF/bottomSheetMf";
import { LENDER_ID } from "../constants";
import NeedHelpDC from "../NeedHelpDC";
const AutoPay = ({ height, stepperData, changeBankAccount, triggerAction, goToDigioAction, bankDetails, bankUrl, backAction, continuePress, isRedirected, isSuccessful, autoDebitDate, mandateCallBack, 
// @ts-ignore
mandateState, contactUsAction, loading = false, digioMandateSuccess, digioMandateFailed, digioMandateCancelled, needHelpAction, mandateErrorData, showExtraMandateError = false, onMandateErrorModalClose, firstAutoPayFailed = false, isJupiter, lenderId, contactUsDetails, resetErrorAction, }) => {
    const [redirectionHalfCard, setRedirectionHalfCard] = useState(false);
    const [successfull, setSuccessfull] = useState(false);
    const [successLottie, setSuccessLottie] = useState("");
    const [infoCard, setInfoCard] = useState(false);
    const [iLottieFetched, setLottieFetched] = useState(false);
    const [errorCTAClicked, setErrorCTAClicked] = useState(false);
    const [renderInfoCTA, setRenderInfoCTA] = useState(false);
    const [isFromMandateCallback, setFromMandateCallback] = useState(false);
    const [closeMandateCallback, setCloseMandateCallback] = useState(false);
    const [hasUserCancelled, setUserCancelled] = useState(false);
    const [primaryCtaLoading, setPrimaryCtaLoading] = useState(false);
    const [secondaryCtaLoading, setSecondaryCtaLoading] = useState(false);
    const [showNeedHelp, setShowNeedHelp] = useState(false);
    const [_showExtraMandateError, setShowExtraMandateError] = useState(showExtraMandateError ? showExtraMandateError : false);
    const [_mandateErrorData, setMandateErrorData] = useState(mandateErrorData ? mandateErrorData : undefined);
    const stepperProps = {
        data: stepperData,
        type: StepperTypeTokens.HORIZONTAL,
        onPress: null
    };
    // @ts-ignore
    const bankaccountNumber = bankDetails.accountNumber.slice(-4);
    const successJsonLottie = "https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json";
    useEffect(() => {
        fetch(successJsonLottie, {
            method: "GET",
        })
            .then((response) => response.json())
            .then((responseData) => {
            setSuccessLottie(responseData);
            setLottieFetched(true);
        })
            .catch((error) => {
            console.log(error);
        });
    }, []);
    useEffect(() => {
        if (mandateCallBack || digioMandateFailed || digioMandateCancelled || digioMandateSuccess) {
            setFromMandateCallback(true);
            setCloseMandateCallback(true);
        }
        else {
            setFromMandateCallback(false);
            setCloseMandateCallback(false);
        }
    }, [mandateCallBack, digioMandateCancelled, digioMandateSuccess, digioMandateFailed]);
    useEffect(() => {
        setShowExtraMandateError(showExtraMandateError);
        setMandateErrorData(mandateErrorData);
    }, [showExtraMandateError, mandateErrorData]);
    useEffect(() => {
        if (mandateState === "COMPLETED") {
            setUserCancelled(false);
            setSuccessfull(true);
            setTimeout(() => {
                triggerAction({
                    ...continuePress
                });
            }, 3000);
        }
        else if (mandateState === "FINISHED") {
            setSuccessfull(true);
            setTimeout(() => {
                triggerAction({
                    ...continuePress
                });
            }, 3000);
        }
        else if (mandateState === "USER_CANCELLED") {
            setUserCancelled(true);
            setSuccessfull(false);
        }
        else if (mandateState === "FAILED") {
            setSuccessfull(false);
            setUserCancelled(false);
        }
    }, [mandateState]);
    useEffect(() => {
        setTimeout(() => {
            if (renderInfoCTA) {
                setRenderInfoCTA(false);
            }
            if (errorCTAClicked) {
                setErrorCTAClicked(false);
            }
        }, 500);
    }, [renderInfoCTA, errorCTAClicked]);
    useEffect(() => {
        if (isRedirected) {
            setRedirectionHalfCard(true);
        }
        if (isSuccessful && !digioMandateSuccess) {
            setSuccessfull(true);
            setTimeout(() => {
                triggerAction({
                    ...continuePress
                });
            }, 3000);
        }
    }, [isRedirected, isSuccessful, digioMandateSuccess]);
    const renderVerificationSuccess = () => {
        return (React.createElement(View, { style: styles.successCard },
            Platform.OS === 'ios'
                && React.createElement(LottieView, { source: { uri: "https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json" }, style: { width: 70, height: 70 }, autoPlay: true, loop: true }),
            Platform.OS !== 'ios'
                && successLottie !== ""
                && React.createElement(LottieView, { source: successLottie, style: { width: 70, height: 'auto' }, autoPlay: true, loop: true }),
            React.createElement(View, { style: styles.halfCardTitle },
                React.createElement(Typography, { label: "Mandate set up successfully!", fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 24 })),
            React.createElement(View, { style: styles.halfCardDescription },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: "You will be redirected to next step in few seconds", fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, paddingTop: 4 })),
            React.createElement(View, { style: styles.successCTA },
                React.createElement(Button, { id: "bt_autoPay_continue", type: ButtonTypeTokens.LargeSoftFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: "Continue", width: ButtonWidthTypeToken.FULL, onPress: () => {
                        if (continuePress) {
                            triggerAction({
                                ...continuePress
                            });
                        }
                    } }))));
    };
    const renderWhyAutoPayCard = () => {
        return (React.createElement(View, { style: styles.whyAutoPay },
            React.createElement(View, null,
                React.createElement(Typography, { label: "Why setup mandate?", fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: styles.whyAutoPayDesc },
                React.createElement(Typography, { label: "With a bank mandate, you can pay your EMIs automatically and on time, avoiding the hassle of manual repayments each month, ensuring a seamless and secure payment experience.", fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, paddingTop: 4 })),
            React.createElement(View, { style: styles.whyAutoPayCTA },
                React.createElement(Button, { id: "bt_autoPay_okGotIt", type: ButtonTypeTokens.LargeSoftFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: "Ok, got it!", width: ButtonWidthTypeToken.FULL, onPress: () => {
                        setRenderInfoCTA(true);
                    } }))));
    };
    const renderErrorContent = () => {
        return (React.createElement(View, { style: styles.failureCard },
            React.createElement(Icon, { name: IconTokens.SystemError, size: IconSizeTokens.XXXXXL }),
            React.createElement(View, { style: styles.halfCardTitle },
                React.createElement(Typography, { label: "Mandate request failed", fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 24 })),
            React.createElement(View, { style: styles.halfCardDescription },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: "We encountered an error while setting up mandate. Please retry the process.", fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, paddingTop: 4 })),
            React.createElement(View, { style: styles.errorCTA },
                React.createElement(View, null,
                    React.createElement(Button, { type: ButtonTypeTokens.LargeSoftFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: "Retry mandate setup", width: ButtonWidthTypeToken.FULL, onPress: () => {
                            setErrorCTAClicked(true);
                            setCloseMandateCallback(false);
                            setFromMandateCallback(false);
                        } }),
                    React.createElement(View, { style: {
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginTop: 24,
                        } },
                        React.createElement(Typography, { label: "Need help?", fontSize: FontSizeTokens.SM, lineHeight: 24, fontWeight: "400", fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Night }),
                        React.createElement(View, { style: { width: 5 } }),
                        React.createElement(TouchableOpacity, { onPress: () => {
                                triggerAction({
                                    ...contactUsAction
                                });
                            } },
                            React.createElement(Typography, { label: "Contact us", fontSize: FontSizeTokens.SM, lineHeight: 24, fontWeight: "600", fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Primary_100 }))),
                    Platform.OS === "ios" &&
                        React.createElement(Space, { size: SizeTypeTokens.MD })))));
    };
    const handleResetError = async () => {
        await triggerAction(resetErrorAction);
    };
    const renderUserCancelledContent = () => {
        return (React.createElement(View, { style: styles.userCancelledCard },
            React.createElement(Icon, { name: IconTokens.SystemError, size: IconSizeTokens.XXXXXXL }),
            React.createElement(View, { style: styles.halfCardTitle },
                React.createElement(Typography, { label: "Mandate setup canceled", fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 24 })),
            React.createElement(Typography, { textAlign: TextAlignTokens.center, label: "A mandate setup is required for the completion of your loan application", fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, paddingTop: 4 }),
            React.createElement(View, { style: styles.errorCTA },
                React.createElement(View, null,
                    React.createElement(Button, { type: ButtonTypeTokens.LargeSoftFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: "Retry mandate setup", width: ButtonWidthTypeToken.FULL, onPress: () => {
                            setErrorCTAClicked(true);
                            setCloseMandateCallback(true);
                            handleResetError();
                        } }),
                    React.createElement(View, { style: {
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginTop: 16,
                        } },
                        React.createElement(Typography, { label: "Need help?", fontSize: FontSizeTokens.SM, lineHeight: 24, fontWeight: "400", fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Night }),
                        React.createElement(View, { style: { width: 5 } }),
                        React.createElement(TouchableOpacity, { onPress: () => {
                                triggerAction({
                                    ...contactUsAction
                                });
                            } },
                            React.createElement(Typography, { label: "Contact us", fontSize: FontSizeTokens.SM, lineHeight: 24, fontWeight: "600", fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Primary_100 })))))));
    };
    const renderMandateStatusCard = () => {
        return isFromMandateCallback && closeMandateCallback && (React.createElement(View, { style: { position: 'absolute', bottom: 0 } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: hasUserCancelled || mandateState === "FAILED" ? 270 : Platform.OS === "ios" ? 270 : 260, width: '100%', closeFunction: () => {
                    setCloseMandateCallback(false);
                    setFromMandateCallback(false);
                    handleResetError();
                }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: !successfull, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width)) ? Platform.OS !== "ios" ? Dimensions.get('window').height + 10 : Dimensions.get('window').height : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true, isCTAClicked: errorCTAClicked },
                (mandateState === "COMPLETED" || mandateState === "FINISHED" || digioMandateSuccess) && iLottieFetched && renderVerificationSuccess(),
                hasUserCancelled || digioMandateCancelled && renderUserCancelledContent())));
    };
    const renderRedirectionHalfCard = () => {
        return isRedirected && redirectionHalfCard &&
            (React.createElement(View, { style: { position: 'absolute', bottom: 0 } },
                React.createElement(BottomSheet, { autoAdjustHeight: false, height: !successfull ? 270 : 244, width: '100%', closeFunction: () => setRedirectionHalfCard(false), alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: !successfull, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').height : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 504, routeId: "routeId", handleKeyboard: true, isCTAClicked: errorCTAClicked }, lenderId.toLowerCase() === LENDER_ID.DSP.toLowerCase() ?
                    iLottieFetched && successfull && renderVerificationSuccess()
                    :
                        iLottieFetched && successfull
                            ? renderVerificationSuccess()
                            : renderErrorContent())));
    };
    const renderInfoCard = () => {
        return infoCard &&
            (React.createElement(View, { style: { position: 'absolute', bottom: 0 } },
                React.createElement(BottomSheet, { autoAdjustHeight: false, height: 244, width: '100%', closeFunction: () => setInfoCard(false), alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width)) ? Platform.OS === "ios" ? Dimensions.get('window').height + 10 : Dimensions.get('window').height : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 504, routeId: "routeId", handleKeyboard: true, isCTAClicked: renderInfoCTA }, renderWhyAutoPayCard())));
    };
    const renderErrorMandateModal = () => {
        const errorData = _mandateErrorData;
        const title = errorData?.header;
        const subtitle = errorData?.message;
        const primaryCtaAction = errorData?.primaryCtaAction;
        const secondaryCtaAction = errorData?.secondaryCtaAction;
        const tertiaryCtaAction = errorData?.tertiaryCtaAction;
        const primaryCtaText = errorData?.primaryCtaText;
        const secondaryCtaText = errorData?.secondaryCtaText;
        const tertiaryCtaText = errorData?.tertiaryCtaText;
        return (React.createElement(BottomSheetMf, { modalVisible: _showExtraMandateError, onModalClose: () => {
                onMandateErrorModalClose &&
                    onMandateErrorModalClose();
                setShowExtraMandateError(false);
            } },
            React.createElement(View, { style: {
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center'
                } },
                React.createElement(Icon, { name: IconTokens.SystemError })),
            title &&
                (title !== null && title !== 'null') &&
                (React.createElement(React.Fragment, null,
                    React.createElement(Space, { size: SizeTypeTokens.XXXL }),
                    React.createElement(Typography, { label: title, typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center }))),
            subtitle &&
                (subtitle !== null && subtitle !== 'null') &&
                (React.createElement(React.Fragment, null,
                    React.createElement(Space, { size: SizeTypeTokens.MD }),
                    React.createElement(Typography, { label: subtitle, typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.center }))),
            primaryCtaAction &&
                React.createElement(React.Fragment, null,
                    React.createElement(Space, { size: SizeTypeTokens.XXXL }),
                    React.createElement(Button, { typeDLS: ButtonTypeDLS.PRIMARY, sizeDLS: ButtonSizeDLS.MEDIUM, label: primaryCtaText ? primaryCtaText : 'Test', loading: primaryCtaLoading, onPress: async () => {
                            setPrimaryCtaLoading(true);
                            primaryCtaAction &&
                                await triggerAction({
                                    type: primaryCtaAction,
                                    routeId: 'DIGIO_MANDATE_SIGN',
                                    payload: {}
                                });
                            setPrimaryCtaLoading(false);
                            setShowExtraMandateError(false);
                        } })),
            secondaryCtaAction &&
                React.createElement(React.Fragment, null,
                    React.createElement(Space, { size: SizeTypeTokens.LG }),
                    React.createElement(Button, { typeDLS: ButtonTypeDLS.SECONDARY, sizeDLS: ButtonSizeDLS.MEDIUM, label: secondaryCtaText ? secondaryCtaText : 'Test', loading: secondaryCtaLoading, onPress: async () => {
                            setSecondaryCtaLoading(true);
                            secondaryCtaAction &&
                                await triggerAction({
                                    type: secondaryCtaAction,
                                    routeId: 'DIGIO_MANDATE_SIGN',
                                    payload: {}
                                });
                            setSecondaryCtaLoading(false);
                            setShowExtraMandateError(false);
                        } })),
            tertiaryCtaAction &&
                React.createElement(View, { style: {
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    } },
                    React.createElement(Space, { size: SizeTypeTokens.XXXL }),
                    React.createElement(TouchableOpacity, { style: {
                            display: 'flex',
                            flexDirection: 'row'
                        }, onPress: async () => {
                            tertiaryCtaAction &&
                                await triggerAction({
                                    type: tertiaryCtaAction,
                                    routeId: 'DIGIO_MANDATE_SIGN',
                                    payload: {}
                                });
                            setShowExtraMandateError(false);
                        } },
                        React.createElement(Typography, { label: 'Need help? ', typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Night }),
                        React.createElement(Typography, { label: tertiaryCtaText ? tertiaryCtaText : 'Test', typeDLS: TypographyTypeDLS.B1S, color: ColorTokens.Primary_100 })))));
    };
    const _headerChild = useMemo(() => {
        return (React.createElement(Header, { id: "bt_autoPay_goBack", type: HeaderTypeTokens.verification, stepperProps: stepperProps, isBackButton: true, needHelpIcon: true, needHelpAction: () => setShowNeedHelp(true), isFromJupiter: isJupiter, title: "Setup mandate", onPress: () => {
                if (backAction) {
                    triggerAction(backAction);
                }
            } }));
    }, []);
    return (React.createElement(View, { style: [styles.container, { height: Platform.OS === "ios" ? height - 16 : height - 4 }] },
        React.createElement(View, { style: styles.contentContainer },
            React.createElement(View, { style: styles.headerStyle }, _headerChild),
            React.createElement(View, { style: { height: height - 200 } },
                React.createElement(ScrollView, { showsVerticalScrollIndicator: false },
                    React.createElement(View, { style: styles.landingTitle },
                        React.createElement(Typography, { label: "Setup mandate for hassle-free EMI payments", fontSize: FontSizeTokens.MD, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Poppins, lineHeight: 24, fontWeight: "600" })),
                    firstAutoPayFailed &&
                        React.createElement(React.Fragment, null,
                            React.createElement(View, { style: {
                                    display: 'flex',
                                    flexDirection: 'row',
                                    padding: 8,
                                    backgroundColor: '#FDECEB',
                                    borderRadius: 8,
                                } },
                                React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_ERROR_DLS, size: IconSizeTokens.LG }),
                                React.createElement(Space, { size: SizeTypeTokens.MD }),
                                React.createElement(View, { style: {
                                        flex: 1
                                    } },
                                    React.createElement(Typography, { label: 'Your last auto pay attempt failed. Please select another account and retry', typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Night }))),
                            React.createElement(Space, { size: SizeTypeTokens.XL })),
                    React.createElement(View, { style: styles.bankCardContainer },
                        React.createElement(View, { style: styles.bankDetailsCard },
                            React.createElement(View, { style: styles.accountDetails },
                                React.createElement(View, { style: styles.accountContent },
                                    React.createElement(Typography
                                    // @ts-ignore
                                    , { 
                                        // @ts-ignore
                                        label: bankDetails?.bankName, fontWeight: '400', fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, lineHeight: 20 }),
                                    React.createElement(Space, { size: SizeTypeTokens.SM }),
                                    React.createElement(Typography, { label: `XXXX ${bankaccountNumber}`, fontWeight: '600', fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Night, lineHeight: 24 }),
                                    React.createElement(Space, { size: SizeTypeTokens.LG }),
                                    React.createElement(TouchableOpacity, { onPress: () => {
                                            if (changeBankAccount) {
                                                triggerAction({
                                                    ...changeBankAccount,
                                                });
                                            }
                                        } },
                                        React.createElement(Typography, { id: "txt_autoPay_changeAccount", label: "Change account", fontWeight: '600', fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Primary_100, lineHeight: 20 }))),
                                React.createElement(Image, { uri: `${bankUrl}`, size: ImageSizeTokens.SIZE_40 }))),
                        React.createElement(View, { style: styles.lineStyle }),
                        React.createElement(View, { style: styles.autoDebitCard },
                            React.createElement(Typography, { label: 'Auto debit date', fontWeight: '400', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Charcoal, lineHeight: 20 }),
                            React.createElement(Typography, { label: `${autoDebitDate}`, fontWeight: '600', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.MD, color: ColorTokens.Grey_Night, lineHeight: 24 }))),
                    React.createElement(Space, { size: SizeTypeTokens.XL }),
                    React.createElement(TouchableOpacity, { onPress: () => {
                            setInfoCard(true);
                        } },
                        React.createElement(Typography, { id: "txt_autoPay_faq", label: "Learn why setup mandate?", fontSize: FontSizeTokens.SM, fontWeight: '600', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Primary_100, lineHeight: 20 })),
                    React.createElement(View, { style: { height: 24 } })))),
        React.createElement(View, { style: styles.bottomContainer },
            React.createElement(View, { style: styles.securityView },
                React.createElement(Icon, { name: IconTokens.SecureIcon, size: IconSizeTokens.XS }),
                React.createElement(Space, { size: SizeTypeTokens.MD }),
                React.createElement(Typography, { label: '100% safe and secure', fontSize: FontSizeTokens.XXS, fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Secondary_100, fontWeight: '500', lineHeight: 16 })),
            React.createElement(Button, { id: "bt_autoPay_continue", type: ButtonTypeTokens.LargeFilled, label: firstAutoPayFailed
                    ? 'Change account and retry'
                    : isSuccessful === false && isRedirected
                        ? "Confirm details and retry"
                        : "Continue", fontSize: FontSizeTokens.SM, width: ButtonWidthTypeToken.FULL, loading: loading, onPress: async () => {
                    if (firstAutoPayFailed) {
                        await triggerAction({
                            ...changeBankAccount
                        });
                    }
                    else if (goToDigioAction) {
                        triggerAction({
                            ...goToDigioAction
                        });
                    }
                } })),
        renderInfoCard(),
        renderRedirectionHalfCard(),
        renderMandateStatusCard(),
        renderErrorMandateModal(),
        showNeedHelp && React.createElement(NeedHelpDC, { showNeedHelp: showNeedHelp, setShowNeedHelp: setShowNeedHelp, contactUsDetails: contactUsDetails, isFromJupiter: isJupiter })));
};
const styles = StyleSheet.create({
    container: {
        // height: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').height  : Dimensions.get('window').height - 112,
        marginHorizontal: -16
    },
    bankCardContainer: {
        width: '100%',
        borderWidth: 1,
        borderRadius: 12,
        borderColor: "#E4E7EC",
        flexDirection: 'column',
        alignSelf: 'center',
    },
    lineStyle: {
        borderWidth: 0.1,
        borderColor: '#E4E7EC',
    },
    bottomNoteContainer: {
        backgroundColor: '#F9FAFB',
        flexDirection: 'row',
        padding: 12,
        borderBottomRightRadius: 12,
        borderTopWidth: 1,
        borderColor: '#E4E7EC',
        borderBottomLeftRadius: 12,
        justifyContent: 'flex-start'
    },
    modalView: {
        justifyContent: 'flex-end'
    },
    contentContainer: {
        paddingHorizontal: 16,
        flex: 1
    },
    successCard: {
        alignItems: "center", flex: 1, height: 260, padding: 16
    },
    failureCard: {
        alignItems: "center", flex: 1, height: 270, padding: 16, justifyContent: 'space-between'
    },
    userCancelledCard: {
        alignItems: "center",
        flex: 1,
        height: 260,
        padding: 16,
        justifyContent: 'space-between',
    },
    successLottie: { width: 70, height: 'auto' },
    halfCardTitle: { marginTop: 16 },
    halfCardDescription: { marginTop: 4 },
    successCTA: {
        position: 'absolute',
        bottom: 0,
        width: '100%',
        paddingHorizontal: 16,
        marginBottom: 16,
        marginTop: 24,
    },
    whyAutoPay: { flex: 1, padding: 16, justifyContent: 'space-between' },
    whyAutoPayDesc: { marginTop: -24 },
    whyAutoPayCTA: {
        width: '100%',
        alignItems: 'center',
        alignContent: 'center',
        alignSelf: 'center',
        justifyContent: 'flex-end'
    },
    errorCTA: {
        width: '100%',
        marginTop: 16,
        flexDirection: "column"
    },
    landingTitle: { marginTop: 24, marginBottom: 16 },
    bankDetailsCard: { paddingTop: 16, paddingLeft: 16, paddingRight: 16, paddingBottom: 12 },
    accountDetails: { flexDirection: 'row', justifyContent: 'space-between' },
    headerStyle: {
        marginHorizontal: -16, ...Platform.OS === "ios" && {
            marginTop: 24
        }
    },
    accountContent: { width: 180, flexDirection: 'column' },
    autoDebitCard: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: 16,
        borderBottomRightRadius: 12,
        borderBottomLeftRadius: 12,
    },
    mandateInfoImage: { marginTop: 2 },
    bottomContainer: {
        position: 'absolute',
        bottom: 0,
        padding: 16,
        marginTop: 5,
        width: '100%',
        alignSelf: 'center',
        alignContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        borderTopWidth: 1,
        borderColor: '#F1F3F5',
        paddingVertical: 16,
        backgroundColor: 'white',
    },
    securityView: { flexDirection: 'row', marginBottom: 8 }
});
// @ts-ignore
export default (AutoPay);
